import React, { useContext, type JSX } from "react";
import type { actionCreators } from "./SearchOverviewGraphActions";
import type { ICategory, ISearchOverviewState } from "./SearchOverviewGraphReducer";

interface ISearchOverviewContext extends ISearchOverviewState {
    actions: typeof actionCreators;
    emptyState: JSX.Element;
    filtersRow: JSX.Element;
    chosenSites: any;

    getSiteColor(site: string): string;

    getData(category?: ICategory, params?: Record<string, any>): Promise<any>;

    isMonthsToDateActive: boolean;
}

export const searchOverviewContext = React.createContext<ISearchOverviewContext>(null);
export const useSearchOverviewContext = (): ISearchOverviewContext => useContext(searchOverviewContext);
